// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1990":"8df3925cda52cd44","2888":"e22ddfbac88e2274"}[chunkId] + ".css";
};